import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../reducers/index';
import { thunk } from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension';

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk as any),
    ((typeof window !== 'undefined') && window?.["__REDUX_DEVTOOLS_EXTENSION__"]) ?  window["__REDUX_DEVTOOLS_EXTENSION__"]() : a=> a
  ))

export default store
